import { useRouter } from 'next/router';
import React, { useState, useEffect } from 'react'
import Navbar from "../../components/Layouts/Navbar";
import Footer from "../../components/Layouts/Footer";
import HeroBanner from '../../components/Common/HeroBanner';
import Breadcrumb from '../../components/Layouts/Breadcrumb';
import TabSection from '../../components/events/TabSection'
import SideBarForm from '../../components/Common/SideBarForm';
import DateCard from './DateCard';
import axios from 'axios';
import { useGetInfographicsQuery } from '../../components/Store/Features/InfographicsAPI';

const EventProfile = () => {
  const router = useRouter();
  const { slug } = router.query;
  const { data: posts, error, isLoading } = useGetInfographicsQuery('/event/' + slug);

  useEffect(()=>{
    if (isLoading === false) {
      if(posts === null){
        router.push('/404')
      }
    }
  }, [router , isLoading , posts])

  return (
    <>
      <Navbar />
      {posts?.banner_image && 
      <HeroBanner
        background={process.env.IMG_CDN + posts?.banner_image}
        customPosition="left"
        customHeight="200px"
      />
      }
      <Breadcrumb />
      <div className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:my-10 my-6">
        {
          posts?.is_active ? <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 lg:col-span-8 xl:col-span-9">
            <div className="border-b-2 pb-10">
              <TabSection data={posts} />
            </div>
            
          </div>
          <div className="col-span-12 lg:col-span-4 xl:col-span-3">
            <DateCard data={posts} />
            <SideBarForm
              page_name='Event Profile Page'
              form_name='event-profile-page-form'
              endpoint="/enquiry/newsletter-request"
            />
          </div>
        </div> : <p dangerouslySetInnerHTML={{ __html: posts?.description }}></p> 
        }
        
      </div>

      <Footer />
    </>
  );
};


EventProfile.getInitialProps = async (NextPageContext) => {
  const slugData = NextPageContext.query.slug

  try {
      const response = await axios.get(process.env.API_URL + '/event/' + slugData);
      return {
          title: (response?.data.meta.meta_title) ? response?.data.meta.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: (response?.data.meta.meta_description) ? response?.data.meta.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: (response?.data.meta.meta_keywords) ? response?.data.meta.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      }
  } catch (error) {
      console.error('Error fetching data:', error.message);
      return {
          title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      };
  }
}

export default EventProfile;


